<template>
  <transition name="el-fade-in-linear">
    <div class="invite-member-dialog-component" v-if="showModal">
      <hi-dialog
        class="invite-dialog"
        title="Invite Member"
        @close="showModal = false"
      >
        <div class="modal">
          <div class="title-container">
            <div class="title">Input Member Email</div>
            <el-input
              class="email-input"
              placeholder="Email address"
              v-model="email"
              clearable
            >
            </el-input>
          </div>
          <div class="main-container">
            <div>
              <div class="select-title">
                Select the social account you want this member to manage
              </div>
              <div class="add-btn" @click="showSelectModal = true">
                <div class="icon"></div>
                <span class="text">Add Social Account</span>
              </div>
              <select-item
                style="padding: 0"
                :key="item.id"
                v-for="item in selectList"
                :item="item"
                type="none"
              ></select-item>
            </div>
          </div>
          <div class="bottom-container">
            <hi-button
              :disabled="!validate"
              class="invite-btn"
              @click.native="invite"
              >invite</hi-button
            >
          </div>
        </div>
      </hi-dialog>
      <hi-dialog
        class="select-dialog"
        style="margin-left: 10px"
        v-show="showSelectModal"
        title="Select Social Account"
        @close="showSelectModal = false"
      >
        <div class="modal">
          <div>
            <div
              class="group-container"
              :key="group.title"
              v-for="group in all"
            >
              <div class="group-title">{{ group.title }}</div>
              <select-item
                :key="item.id"
                v-for="item in group.items"
                :item="item"
                :type="item.type"
                @itemClick="itemClick"
              ></select-item>
            </div>
          </div>
        </div>
      </hi-dialog>
    </div>
  </transition>
</template>

<style lang="less">
@import "../../../assets/style/theme.less";
.invite-member-dialog-component {
  position: fixed;
  background: rgba(0, 0, 0, 0.5);
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100;
  .invite-dialog .modal {
    overflow: inherit;
  }
  .invite-dialog,
  .select-dialog {
    height: 700px;
    .modal {
      width: 480px;
      display: flex;
      flex-direction: column;
      overflow: auto;
      flex: 1;

      .title-container {
        padding: 15px 20px 21px 20px;
        border-bottom: solid 1px #e6e6e6;

        .title {
          font-size: 16px;
          font-weight: 500;
        }

        .email-input {
          height: 44px;
          margin-top: 20px;
          border-radius: 4px;

          .el-input__inner {
            background-color: #f0f0f0;
            font-size: 16px;
          }

          .el-input__inner::-webkit-input-placeholder {
            color: @font-color-gray !important;
          }
        }
      }

      .main-container {
        flex: 1;
        overflow: auto;
        padding: 20px 20px 0 20px;

        .select-title {
          font-size: 16px;
          font-weight: 500;
        }

        .add-btn {
          display: flex;
          align-items: center;
          height: 36px;
          margin: 20px 0 7px 0;
          cursor: pointer;

          &:hover,
          &:active {
            opacity: 0.7;
          }

          .icon {
            width: 36px;
            height: 36px;
            background-position: center;
            background-size: contain;
            background-image: url("../../../../public/images/schedule_posts/Add_Detail@3x.png");
            background-repeat: no-repeat;
          }

          .text {
            font-size: 14px;
            margin-left: 15px;
          }
        }
      }

      .bottom-container {
        height: 64px;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0 20px;
        border-top: 1px solid #e5e5e5;

        .invite-btn {
          width: 100%;
        }
      }
    }
  }

  .modal {
    width: 480px;
    display: flex;
    flex-direction: column;
    overflow: auto;
    flex: 1;

    .title-container {
      padding: 15px 20px 21px 20px;
      border-bottom: solid 1px #e6e6e6;

      .title {
        font-size: 16px;
        font-weight: 500;
      }

      .email-input {
        height: 44px;
        margin-top: 20px;
        border-radius: 4px;

        .el-input__inner {
          background-color: #f0f0f0;
          font-size: 16px;
        }

        .el-input__inner::-webkit-input-placeholder {
          color: @font-color-gray !important;
        }
      }
    }

    .main-container {
      flex: 1;
      overflow: auto;
      padding: 20px 20px 0 20px;

      .select-title {
        font-size: 16px;
        font-weight: 500;
      }

      .add-btn {
        display: flex;
        align-items: center;
        height: 36px;
        margin: 20px 0 7px 0;
        cursor: pointer;

        &:hover,
        &:active {
          opacity: 0.7;
        }

        .icon {
          width: 36px;
          height: 36px;
          background-position: center;
          background-size: contain;
          background-image: url("../../../../public/images/schedule_posts/Add_Detail@3x.png");
          background-repeat: no-repeat;
        }

        .text {
          font-size: 14px;
          margin-left: 15px;
        }
      }
    }

    .bottom-container {
      height: 64px;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 20px;
      border-top: 1px solid #e5e5e5;

      .invite-btn {
        width: 100%;
      }
    }
  }

  .group-container {
    .group-title {
      padding: 15px 15px 7px 15px;
      font-size: 16px;
      font-weight: 500;

      .title {
      }
    }
  }
}
</style>

<script>
import hiDialog from "../../common/dialog/Index.vue";
import hiButton from "../../common/button/Index";
import { CURRENT_USER_INFO_SIMPLE } from "../../../store/mutation-types";
import { mapGetters } from "vuex";
import selectItem from "../unlimited_auto/SelectItem";
import { showErrorMsg } from "../../../utils/errors";
import { modifyPublisher, createMember } from "../../../service/member";
import { validateEmail } from "../../../service/user";

export default {
  name: "InviteMemberDialogComponent",
  components: { hiDialog, hiButton, selectItem },
  data() {
    return {
      showModal: false,
      showSelectModal: false,
      email: "",
      selectIds: [],
    };
  },
  methods: {
    open(member) {
      this.showModal = true;
      this.showSelectModal = false;
      // 如果存在form则说明是修改操作
      if (member) {
        this.email = member.memberEmail;
        const selectIds = member.publishers.map((p) => {
          return p.publisherId;
        });
        this.selectIds = selectIds;
        this.id = member.id;
      } else {
        this.selectIds = [];
        this.email = this.id = "";
      }
    },
    /**
     * 关闭页面
     */
    close() {
      this.showSelectModal = this.showModal = false;
    },
    async invite() {
      const loading = this.$loading();
      try {
        const existing = await validateEmail({ email: this.email });
        // 不存在则进行提示
        if (!existing) {
          await this.$confirm.show({
            text: `Invite ${this.email} as a member. Confirm the email is correct.`,
            yesText: "OK",
            cancelText: "Cancel",
            showClose: false,
          });
        }
        // 判断用户是否
        const form = {
          email: this.email,
          ids: this.selectIds,
        };
        // 获取用户所有member
        let hasSameEmail = this.user.teamMemberList.find(
          (m) => m.memberEmail === form.email
        );
        // 如果是修改，切账号和之前一样则无视次校验
        const currentMember = this.user.teamMemberList.find(
          (m) => m.id === this.id
        );
        // 计算邮箱是否被修改
        const emailNotChange =
          currentMember && currentMember.memberEmail === form.email;
        if (emailNotChange) {
          hasSameEmail = false;
        }
        // 验证邮箱是否被重复邀请过
        if (hasSameEmail) {
          await this.$alert.show(this.$t("inviteMemberPage.sameEmailMsg"));
          return;
        }
        // 如果当前账号是自己弹出提示
        if (this.user.email === form.email) {
          await this.$alert.show(this.$t("inviteMemberPage.isMeEmail"));
          return;
        }
        if (this.id) {
          form.memberId = this.id;
          form.emailNotChange = emailNotChange;
          await modifyPublisher(form);
        } else {
          // 验证用户可以添加的member是否达到上限，如果达到上限弹出升级提示
          if (this.user.memberRemaining === 0) {
            // 并彈出升級提示
            await this.$confirm.show({
              text: this.$t("myPlanPage.teamMember.upgradeText"),
              yesText: this.$t("common.upgrade"),
            });
            this.$router.push({ name: "UpgradePage" });
            return;
          }
          await createMember(form);
        }
        this.close();
      } catch (e) {
        showErrorMsg(e);
      } finally {
        loading.close();
      }
    },
    /**
     * 单条记录点击事件
     */
    itemClick(item) {
      // limited账号禁止发送
      if (item.type === "forbid") {
        this.$msgbox({
          title: "",
          showCancelButton: false,
          message: "You can only add unlimited schedules account.",
          distinguishCancelAndClose: true,
          cancelButtonText: this.$t("common.ok"),
        });
        return;
      }
      // 查看以选中项中是否包含点击项
      const index = this.selectIds.findIndex((id) => {
        return item.publisherId === id;
      });
      // 如果不存在，则添加当前点击项到数组中
      if (index === -1) {
        this.selectIds.push(item.publisherId);
      } else {
        // 否则删除该项
        this.selectIds.splice(index, 1);
      }
    },
    /**
     * select按钮点击事件
     */
    async saveSelectClick() {
      const loading = this.$loading();
      try {
        await this.teamMemberDetail.mulModifyPublisher({ ids: this.selectIds });
        this.$router.go(-1);
        this.$toast.show({ message: this.$t("common.success") });
      } catch (e) {
        showErrorMsg(e);
      } finally {
        loading.close();
      }
    },
  },
  computed: {
    ...mapGetters({
      user: CURRENT_USER_INFO_SIMPLE,
    }),
    validate() {
      // 首先判断邮箱格式是否正确
      const reg = new RegExp(
        "^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$"
      ); // 邮箱正则表达式
      // 输入项必须为邮箱
      if (!reg.test(this.email)) {
        return false;
      }
      // 必须至少选中一个
      if (this.selectList.length === 0) {
        return false;
      }
      return true;
    },
    /**
     * 计算列表
     * @returns {Array}
     */
    all() {
      // 根据类型进行分组(过滤掉member)
      let types = [];
      this.user.linkedInstagramList1.forEach((l) => {
        l.type = this.selectIds.find((id) => id === l.publisherId)
          ? "select"
          : "normal";
      });
      const limitedPublishers = this.user.linkedInstagramList1.filter(
        (l) => !l.isUnlimited && !l.isMember && l.status !== 2
      );
      const unlimitedPublishers = this.user.linkedInstagramList1.filter(
        (l) => l.isUnlimited && !l.isMember && l.status !== 2
      );
      // const facebookPagePublishers = this.user.linkedInstagramList1.filter(l => l.socialNetwork !== 1)
      if (unlimitedPublishers.length > 0) {
        types.push({
          title: this.$t("addUnlimitedAccountPage.normalUnlimitedUserType"),
          items: unlimitedPublishers.map((p) => {
            return { ...p };
          }),
        });
      }
      if (limitedPublishers.length > 0) {
        types.push({
          title: "10 schedules per month",
          // title: this.$t('addUnlimitedAccountPage.freeUserType'),
          items: limitedPublishers.map((p) => {
            return { ...p, type: "forbid" };
          }),
        });
      }
      // if (facebookPagePublishers.length > 0) {
      //   types.push({
      //     title: 'Facebook Page',
      //     items: facebookPagePublishers.map(p => {
      //       return { ...p, type: p.isUnlimited ? undefined : 'forbid' }
      //     })
      //   })
      // }
      return types;
    },
    /**
     * 计算选中列表
     * @returns {*}
     */
    selectList() {
      return this.user.linkedInstagramList1.filter((l) => {
        return this.selectIds.find((id) => id === l.publisherId);
      });
    },
  },
};
</script>
